'use client';

import {
  attendantFilterSexuality,
  attendantSexualOrientationBisexual,
  attendantSexualOrientationHetero,
  attendantSexualOrientationHomosexual,
  filterNotSelected,
} from '@bells/i18n';
import { SexualOrientation } from '@bells/schema/models/attendant';
import { isEmpty } from 'lodash';
import { VenusAndMars } from 'lucide-react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../components/accordion';
import { RadioGroup, RadioGroupItem } from '../../../components/radio-group';
import { useFilter } from '../filter-provider';

export default function FilterSexuality() {
  const { filters, setFilters } = useFilter();

  const sexualPreferences = [
    {
      label: attendantSexualOrientationHetero(),
      value: 'hetero',
      icon: <span>⚤</span>,
    },
    {
      label: attendantSexualOrientationBisexual(),
      value: 'bisexual',
      icon: <span>⚥</span>,
    },
    {
      label: attendantSexualOrientationHomosexual(),
      value: 'homosexual',
      icon: <span>⚣ ⚢</span>,
    },
  ];

  return (
    <AccordionItem value='sexPref'>
      <AccordionTrigger className='px-2 py-3 text-sm font-normal text-muted-foreground hover:text-foreground'>
        <div className='inline-flex flex-1 items-center gap-2'>
          <VenusAndMars className='h-4 w-4' />
          {attendantFilterSexuality()}
        </div>
      </AccordionTrigger>
      <AccordionContent className='space-y-4 px-4'>
        <RadioGroup
          className='flex flex-col gap-4'
          value={filters.sexualOrientation?.toString() ?? ''}
          onValueChange={(val) => {
            setFilters({
              ...filters,
              page: 1,
              sexualOrientation: isEmpty(val)
                ? undefined
                : (val as SexualOrientation),
            });
          }}
        >
          <div className='flex w-full items-center space-x-2'>
            <RadioGroupItem id='sexPref-unknown' value='' />
            <label
              htmlFor='sexPref-unknown'
              className='flex-1 break-words text-sm font-normal leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
            >
              {filterNotSelected()}
            </label>
          </div>

          {sexualPreferences.map((pref) => (
            <div
              key={`sexPref-${pref.value}`}
              className='flex w-full items-center space-x-2'
            >
              <RadioGroupItem id={pref.value} value={pref.value} />
              <label
                htmlFor={pref.value}
                className='inline-flex flex-1 items-center gap-2 text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
              >
                {pref.icon}
                {pref.label}
              </label>
            </div>
          ))}
        </RadioGroup>
      </AccordionContent>
    </AccordionItem>
  );
}
